<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'

// Cor do titulo: Configuração via sitecore com o código da fonte
export default {
  name: 'cText',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    size: {
      type: String,
      default: 'lg',
      description: '(xs / sm / md / lg / xl)',
    },
    weight: {
      type: String,
      default: 'lighter',
      description: '(100-800 / bolder / lighter / normal)',
    },
    align: {
      type: String,
      default: 'left',
    },
  },
  setup(props) {
    const classes = computed(() => [
      'c-text',
      `c-text--${props.size}`,
      `c-text--${props.weight}`,
      `c-text--${props.align}`,
    ])

    const styles = computed(() => ({
      color: props.color,
    }))

    onMounted(() => {
      const getGoogleTranslateIcon = document.getElementById('gtx-trans')

      if (getGoogleTranslateIcon) {
        getGoogleTranslateIcon.remove()
      }
    })

    return {
      classes,
      styles,
    }
  },
}
</script>

<style lang="scss" scoped>
.c-text {
  display: flex;
  letter-spacing: -0.0625rem;

  &--xs {
    font-size: 0.875rem;
    line-height: 150%;

    @media (min-width: 768px) {
      font-size: 1rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.125rem;
    }
  }

  &--sm {
    font-size: 0.875rem;
    line-height: 160%;

    @media (min-width: 768px) {
      font-size: 1.125rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.375rem;
    }
  }

  &--md {
    font-size: 1.125rem;
    line-height: 1.5rem;

    @media (min-width: 768px) {
      font-size: 1.3125rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.5rem;
    }
  }

  &--lg {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }

  &--xl {
    font-size: 1.375rem;
    line-height: 1.625rem;
  }

  @include textAlign();

  @include weight();
}
</style>
